import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export function syncActivitiesData(id) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/watch/syncActivitiesData`, null, {
            params: {id},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}
